import { assoc, flatten, propEq } from 'ramda'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import DynamicBlockTable from './DynamicBlockTable'
import DynamicPresentationList from '../presentationList/DynamicPresentationList'
import Modal from '../../../components/structure/Modal'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const DynamicBlockPresentationModal = ({ value, selectedIndex }) => {
  const replies = value[selectedIndex]
  return (
    <>
      <Title size="h5" align="center">
        Item {selectedIndex + 1}
      </Title>
      <Separator weight={4} />
      <DynamicPresentationList replies={replies.map(assoc('blockIndex', -1))} hideCategories />
    </>
  )
}

const DynamicBlockPresentation = ({ value }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(false)

  const questions = React.useMemo(
    () =>
      flatten(value || []).reduce((questions, reply) => {
        const question = reply.question
        const shouldAdd = !questions.some(propEq('id', question.id))
        if (!shouldAdd) return questions
        return [...questions, question]
      }, []),
    []
  )

  return (
    <>
      <DynamicBlockTable value={value} blockQuestions={questions} size="small" onSelect={setSelectedIndex} />
      <Modal open={selectedIndex !== false} onClose={() => setSelectedIndex(false)} width="46rem">
        <DynamicBlockPresentationModal value={value} selectedIndex={selectedIndex} />
      </Modal>
    </>
  )
}

export default DynamicBlockPresentation
